/* Court Vibes, 18.09.2026. Das fliegende Bildchen auf personalisierten Seiten.

   Warum eine eigene Datei: der Versuch, das ueber die Netzwerkanfrage
   auszuloesen, hat nicht getragen. Gemessen am 18.09.2026:
   - Eine von Hand abgeschickte Anfrage an /cart/add.js loeste den Flug
     zuverlaessig aus, das Bildchen wurde erzeugt.
   - Ein echter Klick auf teeinblues Kaufknopf legte das Produkt in den
     Warenkorb, die Zahl am Symbol stieg von 2 auf 3, aber der Flug kam NICHT.
   teeinblue erreicht die Warenkorbschnittstelle also auf einem Weg, den ein
   nachtraeglich gesetzter Haken auf fetch nicht sieht. Die App laedt ihr SDK
   im Kopfbereich, also VOR den eigenen Dateien am Seitenende, und haelt sich
   vermutlich eine eigene Kopie der Funktion.

   Deshalb haengt der Flug am KLICK auf den Knopf, nicht an der Anfrage. Das
   ist unabhaengig von teeinblues Innenleben und damit robust. Preis dieser
   Entscheidung, ehrlich benannt: schlaegt das Hinzufuegen fehl, fliegt das
   Bildchen trotzdem. Bei einer reinen Verzierung ist das vertretbar, bei
   allem, was mit Geld zu tun hat, waere es das nicht.

   Startpunkt ist der Knopf selbst, nicht das Produktbild. Am Handy steht das
   Produktbild ganz oben und ist beim Tippen laengst aus dem Sichtfeld
   gescrollt, ein Flug von dort lief oberhalb des Bildschirms ab und war
   unsichtbar. Der Knopf dagegen ist immer im Bild.

   WELCHES BILD FLIEGT, korrigiert am 18.09.2026.
   Houda hat gemeldet: beim schwarzen T-Shirt fliegt ein weisses T-Shirt.
   Nachgemessen auf /products/vereins-trikot, Mittelwerte ueber die Flaeche:
       .tee-printarea--image img   1000x1000, Deckung 116 von 255
       .tee-mockup-thumbnail        203x203,  Farbe 246,246,247, voll deckend
   Die grosse Vorschau von teeinblue ist also ein Bild mit durchsichtigem
   Rand, das Kleidungsstueck selbst ist ausgeschnitten. Die kleinen
   Vorschaubilder daneben sind dagegen fast weiss.
   Die alte Fassung nahm einfach den ERSTEN Treffer der Liste. Ist die grosse
   Vorschau gerade nicht sichtbar, etwa am Handy, faellt sie durch und das
   weisse Vorschaubild gewinnt. Genau das hat Houda gesehen.
   Jetzt wird nicht der erste, sondern der groesste WIRKLICH SICHTBARE
   Treffer genommen, und die grosse Vorschau von teeinblue hat Vorrang.

   Dazu kommt die Darstellung: das Bildchen zeigte den Ausschnitt aus der
   Bildmitte, also die Brust mit dem Aufdruck, nicht das Kleidungsstueck. In
   assets/cv-teeinblue.css steht jetzt contain statt cover und kein dunkler
   Grund mehr, damit immer das ganze Teil in seiner echten Farbe fliegt.

   Diese Datei fasst nichts vom Theme an und haengt in keiner Kette. Faellt
   sie aus, fehlt nur die Verzierung.

   Probe im Browser:
   getComputedStyle(document.documentElement).getPropertyValue('--cv-flug') */

(function () {
  var FLUGDAUER = 800;
  var GROESSE = 48;
  var VERZOEGERUNG = 220;
  var letzterFlug = 0;

  function imBild(r) {
    return r && r.width > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }

  function sichtbar(el) {
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false;
    var r = el.getBoundingClientRect();
    return r.width > 40 && r.height > 40;
  }

  /* Bewertung: teeinblues grosse Vorschau zuerst, dann das groesste Bild,
     das wirklich gerendert wird. Ein Bild ohne Quelle zaehlt nicht. */
  function produktbild() {
    var gruppen = [
      { wahl: '.tee-printarea--image img', bonus: 1000000 },
      { wahl: '.tee-mockup-image img', bonus: 900000 },
      { wahl: 'media-gallery .media-gallery__item[aria-hidden="false"] img', bonus: 800000 },
      { wahl: '.product-media img', bonus: 0 },
      { wahl: 'media-gallery img', bonus: 0 },
      { wahl: '.tee-mockup-thumbnail', bonus: 0 },
      { wahl: '.sticky-add-to-cart__image-img', bonus: 0 }
    ];
    var bestes = null;
    var bestwert = -1;
    for (var i = 0; i < gruppen.length; i++) {
      var liste;
      try {
        liste = document.querySelectorAll(gruppen[i].wahl);
      } catch (e) {
        continue;
      }
      for (var k = 0; k < liste.length; k++) {
        var el = liste[k];
        if (!el.currentSrc && !el.src) continue;
        if (!sichtbar(el)) continue;
        var r = el.getBoundingClientRect();
        var wert = gruppen[i].bonus + r.width * r.height;
        if (wert > bestwert) {
          bestwert = wert;
          bestes = el;
        }
      }
    }
    return bestes;
  }

  function warenkorbSymbol() {
    return document.querySelector('cart-icon, .header-actions__cart-icon');
  }

  function fliegen(startRect) {
    try {
      if (Date.now() - letzterFlug < 900) return;
      var ziel = warenkorbSymbol();
      if (!startRect || !ziel) return;
      var z = ziel.getBoundingClientRect();
      if (!z.width || !imBild(startRect)) return;
      letzterFlug = Date.now();

      var halb = GROESSE / 2;
      var d = document.createElement('div');
      d.className = 'cv-flug';
      var bild = produktbild();
      var quelle = bild ? bild.currentSrc || bild.src : '';
      if (quelle) d.style.backgroundImage = 'url("' + quelle + '")';
      d.style.width = GROESSE + 'px';
      d.style.height = GROESSE + 'px';
      d.style.left = Math.round(startRect.left + startRect.width / 2 - halb) + 'px';
      d.style.top = Math.round(startRect.top + startRect.height / 2 - halb) + 'px';
      document.body.appendChild(d);

      var dx = Math.round(z.left + z.width / 2 - (startRect.left + startRect.width / 2));
      var dy = Math.round(z.top + z.height / 2 - (startRect.top + startRect.height / 2));

      function weg() {
        if (d.parentNode) d.remove();
      }

      if (typeof d.animate === 'function') {
        var lauf = d.animate(
          [
            { transform: 'translate(0px, 0px) scale(1)', opacity: 1, offset: 0 },
            {
              transform:
                'translate(' + Math.round(dx * 0.5) + 'px, ' + Math.round(dy * 0.35) + 'px) scale(0.85)',
              opacity: 1,
              offset: 0.55
            },
            { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(0.25)', opacity: 0.1, offset: 1 }
          ],
          { duration: FLUGDAUER, easing: 'cubic-bezier(0.4, 0.05, 0.6, 1)' }
        );
        if (lauf && lauf.finished && lauf.finished.then) {
          lauf.finished.then(weg, weg);
        } else {
          setTimeout(weg, FLUGDAUER + 150);
        }
      } else {
        setTimeout(weg, FLUGDAUER + 150);
      }
    } catch (e) {
      /* Eine Verzierung darf niemals einen Kauf stoeren. */
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      try {
        if (!e.target || !e.target.closest) return;
        var knopf = e.target.closest('.tee-btn--atc');
        if (!knopf) return;
        var r = knopf.getBoundingClientRect();
        setTimeout(function () {
          fliegen(r);
        }, VERZOEGERUNG);
      } catch (x) {}
    },
    true
  );

  document.documentElement.style.setProperty('--cv-flug', 'on');
})();